
export default [

{
    id: 1,
    title: "Life Lessons with Katie Zaferes",
    description: "Award winning swimmer, Katie Zaferes, shares her experiences to help you visualize accomplishing your greatest goals.",
    price: 136,
    coverImg: "katie.png",
    stats: {
        rating: 5.0,
        reviewCount: 6
    },
    location: "Online",
    openSpots: 16,
},

{
    id:2,
    title: "Learn Wedding Photography",
    description: "Interested in becoming a wedding photographer? For beginner and experienced photographers alike, join us in learning techniques required to leave the happy couple memories that'll last a lifetime.",
    price: 125,
    coverImg: "wedding.png",
    stats: {
        rating: 5.0,
        reviewCount: 30
    },
    location: "Online",
    openSpots: 27,
},

{
    id: 3,
    title: "Group Mountain Biking",
    description: "Experience the beautiful Norwegian landscape and meet new friends all while conquering rugged terrain on your mountain bike. (Bike provided!)",
    price: 50,
    coverImg: "biking.png",
    stats: {
        rating: 4.8,
        reviewCount: 120
    },
    location: "Nesbyen, Norway",
    openSpots: 24,
},

{
    id: 3,
    title: "Vatican and Sistine Chapel Tour",
    description: "Traverse the streets of Rome to the Vatican and Sistine Chapel. Surround yourself in the rich history of the city and its artifacts.",
    price: 80,
    coverImg: "vatican.png",
    stats: {
        rating: 4.82,
        reviewCount: 742
    },
    location: "Rome, Italy",
    openSpots: 24,
},
{
    id: 3,
    title: "Swim with Ishigaki Island Sea Turtles",
    description: "Explore the beautiful peaceful waters of Ishigaki Island while swimming among the friendly native sea turtles!",
    price: 37,
    coverImg: "ishigaki.png",
    stats: {
        rating: 4.99,
        reviewCount: 124
    },
    location: "Okinawa, Japan",
    openSpots: 24,
},

]

